unit UClientTablePagination;

interface

uses
  System.SysUtils,
  System.StrUtils,
  Data.DB,
  WEBLib.DB,
  WEBLib.DBCtrls,
  XData.Web.Dataset;

type
  TClientTablePagination = class
  public
    class procedure Apply(const pContainerId, pInfoId, pPaginationId: string;
      const pPageSize: Integer; const pPage: Integer = 0;
      const pEnableSort: Boolean = False); static;
    class procedure ApplyFiltered(const pContainerId, pInfoId, pPaginationId: string;
      const pPageSize: Integer; const pSearchText: string;
      const pPage: Integer = 0; const pEnableSort: Boolean = False); static;
    class procedure AplicarComLoading(const pContainerId, pInfoId,
      pPaginationId, pSearchText: string; const pPageSize: Integer); static;
    class procedure OcultarLoading; static;
    class procedure ApplyFromControls(const pContainerId, pInfoId, pPaginationId,
      pPageSizeControlId, pSearchControlId: string;
      const pDefaultPageSize: Integer; const pPage: Integer = 0;
      const pEnableSort: Boolean = False); static;
    class procedure ApplyAsync(const pContainerId, pInfoId, pPaginationId: string;
      const pPageSize: Integer; const pPage: Integer = 0;
      const pEnableSort: Boolean = False); static;
    class procedure ApplyFromControlsAsync(const pContainerId, pInfoId,
      pPaginationId, pPageSizeControlId, pSearchControlId: string;
      const pDefaultPageSize: Integer; const pPage: Integer = 0;
      const pEnableSort: Boolean = False); static;
    class function ResolveSortFieldFromColumn(const pTable: TDBTableControl;
      const pCol: Integer): string; static;
    class procedure UpdateHeaderVisualState(const pTable: TDBTableControl;
      const pSortField: string; const pSortDesc: Boolean); static;
    class procedure SortDataSet(const pDataSet: TXDataWebDataSet;
      const pFieldName: string; const pDesc: Boolean); static;
    class procedure ToggleAndSortDataSet(const pTable: TDBTableControl;
      const pDataSet: TXDataWebDataSet; const pCol, pRow: Integer;
      var pSortField: string; var pSortDesc: Boolean); static;
  end;

implementation

uses
  UUtils;

type
  TStringRow = array of string;
  TStringRowArray = array of TStringRow;
  TFieldArray = array of TField;
  TStringArray = array of string;

  TSortCache = record
    DataSet: TXDataWebDataSet;
    FieldNames: TStringArray;
    Rows: TStringRowArray;
  end;

var
  GSortCaches: array of TSortCache;

function FindSortCacheIndex(const pDataSet: TXDataWebDataSet): Integer;
var
  lI: Integer;
begin
  Result := -1;

  if not Assigned(pDataSet) then
    Exit;

  for lI := 0 to High(GSortCaches) do
    if GSortCaches[lI].DataSet = pDataSet then
      Exit(lI);
end;

procedure CollectDataFields(const pDataSet: TXDataWebDataSet;
  out pFields: TFieldArray; out pFieldNames: TStringArray);
var
  lI, lCount: Integer;
begin
  SetLength(pFields, 0);
  SetLength(pFieldNames, 0);

  if not Assigned(pDataSet) then
    Exit;

  lCount := 0;
  for lI := 0 to pDataSet.Fields.Count - 1 do
    if pDataSet.Fields[lI].FieldKind = fkData then
      Inc(lCount);

  if lCount = 0 then
    Exit;

  SetLength(pFields, lCount);
  SetLength(pFieldNames, lCount);

  lCount := 0;
  for lI := 0 to pDataSet.Fields.Count - 1 do
    if pDataSet.Fields[lI].FieldKind = fkData then
    begin
      pFields[lCount] := pDataSet.Fields[lI];
      pFieldNames[lCount] := pDataSet.Fields[lI].FieldName;
      Inc(lCount);
    end;
end;

function CaptureRows(const pDataSet: TXDataWebDataSet;
  const pFields: TFieldArray): TStringRowArray;
var
  lRowIndex, lI: Integer;
begin
  SetLength(Result, 0);

  if not Assigned(pDataSet) then
    Exit;

  if Length(pFields) = 0 then
    Exit;

  SetLength(Result, pDataSet.RecordCount);
  pDataSet.First;
  lRowIndex := 0;

  while not pDataSet.Eof do
  begin
    SetLength(Result[lRowIndex], Length(pFields));
    for lI := 0 to High(pFields) do
      Result[lRowIndex][lI] := pFields[lI].AsString;

    Inc(lRowIndex);
    pDataSet.Next;
  end;
end;

procedure AssignFieldValue(const pField: TField; const pValue: string);
begin
  if pValue = EmptyStr then
  begin
    pField.Clear;
    Exit;
  end;

  case pField.DataType of
    ftBoolean:
      pField.AsBoolean := SameText(pValue, 'TRUE') or SameText(pValue, '1') or
        SameText(pValue, '-1') or SameText(pValue, 'T') or SameText(pValue, 'S');
    ftSmallint, ftInteger, ftWord, ftLongWord, ftShortint, ftByte,
    ftLargeint, ftAutoInc:
      pField.AsInteger := StrToIntDef(Trim(pValue), 0);
    ftFloat, ftCurrency, ftBCD, ftFMTBcd, ftSingle, ftExtended:
      pField.AsFloat := StrToFloatDef(StringReplace(Trim(pValue), ',', '.', [rfReplaceAll]), 0);
  else
    pField.AsString := pValue;
  end;
end;

procedure RewriteDataSetRows(const pDataSet: TXDataWebDataSet;
  const pFieldNames: TStringArray; const pRows: TStringRowArray);
var
  lI, lJ: Integer;
begin
  pDataSet.Close;
  pDataSet.Open;

  for lI := 0 to High(pRows) do
  begin
    pDataSet.Append;
    for lJ := 0 to High(pFieldNames) do
      AssignFieldValue(pDataSet.FieldByName(pFieldNames[lJ]), pRows[lI][lJ]);
    pDataSet.Post;
  end;
end;

procedure CacheOriginalOrder(const pDataSet: TXDataWebDataSet);
var
  lCacheIndex: Integer;
  lFields: TFieldArray;
  lFieldNames: TStringArray;
begin
  if not Assigned(pDataSet) then
    Exit;

  lCacheIndex := FindSortCacheIndex(pDataSet);
  if lCacheIndex >= 0 then
    Exit;

  CollectDataFields(pDataSet, lFields, lFieldNames);
  if Length(lFields) = 0 then
    Exit;

  pDataSet.DisableControls;
  try
    SetLength(GSortCaches, Length(GSortCaches) + 1);
    GSortCaches[High(GSortCaches)].DataSet := pDataSet;
    GSortCaches[High(GSortCaches)].FieldNames := lFieldNames;
    GSortCaches[High(GSortCaches)].Rows := CaptureRows(pDataSet, lFields);
  finally
    pDataSet.EnableControls;
  end;
end;

function RestoreOriginalOrder(const pDataSet: TXDataWebDataSet): Boolean;
var
  lCacheIndex: Integer;
begin
  Result := False;

  lCacheIndex := FindSortCacheIndex(pDataSet);
  if lCacheIndex < 0 then
    Exit;

  pDataSet.DisableControls;
  try
    RewriteDataSetRows(pDataSet,
      GSortCaches[lCacheIndex].FieldNames,
      GSortCaches[lCacheIndex].Rows);
    Result := True;
  finally
    pDataSet.EnableControls;
  end;
end;

class function TClientTablePagination.ResolveSortFieldFromColumn(
  const pTable: TDBTableControl; const pCol: Integer): string;
var
  lI, lSortableIndex: Integer;
  lDirectField, lSortableField: string;
begin
  Result := EmptyStr;

  if not Assigned(pTable) then
    Exit;

  if pCol < 0 then
    Exit;

  lDirectField := EmptyStr;
  if pCol < pTable.Columns.Count then
  begin
    if (pTable.Columns[pCol].Tag <> 1) then
      lDirectField := Trim(pTable.Columns[pCol].DataField);
  end;

  lSortableField := EmptyStr;
  lSortableIndex := -1;
  for lI := 0 to pTable.Columns.Count - 1 do
  begin
    if (pTable.Columns[lI].Tag = 1) or Trim(pTable.Columns[lI].DataField).IsEmpty then
      Continue;

    Inc(lSortableIndex);
    if lSortableIndex = pCol then
    begin
      lSortableField := Trim(pTable.Columns[lI].DataField);
      Break;
    end;
  end;

  if not lDirectField.IsEmpty then
    Exit(lDirectField);

  if not lSortableField.IsEmpty then
    Exit(lSortableField);

  Result := lSortableField;
end;

class procedure TClientTablePagination.UpdateHeaderVisualState(
  const pTable: TDBTableControl; const pSortField: string;
  const pSortDesc: Boolean);
var
  lI: Integer;
  lSortable: Boolean;
  lDataField, lBaseTitle: string;
  lColIndex: Integer;
begin
  if not Assigned(pTable) then
    Exit;

  for lI := 0 to pTable.Columns.Count - 1 do
  begin
    lColIndex := lI;
    lDataField := Trim(pTable.Columns[lI].DataField);
    lSortable := (pTable.Columns[lI].Tag <> 1) and not lDataField.IsEmpty;

    lBaseTitle := Trim(pTable.Columns[lI].Title);
    if EndsText('▲', lBaseTitle) or EndsText('▼', lBaseTitle) then
    begin
      if Length(lBaseTitle) > 0 then
        lBaseTitle := Trim(Copy(lBaseTitle, 1, Length(lBaseTitle) - 1));
    end;

    pTable.Columns[lI].Title := lBaseTitle;

    asm
      var lContainer = document.getElementById(pTable.ElementID);
      if (lContainer) {
        var lHeader = lContainer.querySelector('table thead tr th:nth-child(' + String(lColIndex + 1) + ')');
        if (!lHeader) {
          lHeader = lContainer.querySelector('table thead tr td:nth-child(' + String(lColIndex + 1) + ')');
        }
        if (!lHeader) {
          lHeader = lContainer.querySelector('table tr:first-child th:nth-child(' + String(lColIndex + 1) + ')');
        }
        if (!lHeader) {
          lHeader = lContainer.querySelector('table tr:first-child td:nth-child(' + String(lColIndex + 1) + ')');
        }

        if (lHeader) {
          var lCursor = lSortable ? 'pointer' : 'default';
          lHeader.style.cursor = lCursor;
          lHeader.style.setProperty('cursor', lCursor, 'important');
          lHeader.style.userSelect = lSortable ? 'none' : 'auto';

          var lChildren = lHeader.querySelectorAll('*');
          lChildren.forEach(function(lChild) {
            lChild.style.cursor = lCursor;
            lChild.style.setProperty('cursor', lCursor, 'important');
          });
        }
      }
    end;
  end;
end;

class procedure TClientTablePagination.SortDataSet(const pDataSet: TXDataWebDataSet;
  const pFieldName: string; const pDesc: Boolean);
var
  lRows: TStringRowArray;
  lTemp: TStringRow;
  lFields: TFieldArray;
  lFieldNames: TStringArray;
  lFieldIndex, lTargetFieldIndex: Integer;
  lI, lJ: Integer;
  lCompare: Integer;
  lA, lB: string;

  function CompareValues(const pA, pB: string): Integer;
  var
    lANumber, lBNumber: Double;
    lIsNumericField: Boolean;
  begin
    lIsNumericField := lFields[lTargetFieldIndex].DataType in
      [ftSmallint, ftInteger, ftWord, ftLongWord, ftShortint, ftByte,
       ftLargeint, ftAutoInc, ftFloat, ftCurrency, ftBCD, ftFMTBcd,
       ftSingle, ftExtended];

    if lIsNumericField then
    begin
      lANumber := StrToFloatDef(StringReplace(Trim(pA), ',', '.', [rfReplaceAll]), 0);
      lBNumber := StrToFloatDef(StringReplace(Trim(pB), ',', '.', [rfReplaceAll]), 0);

      if lANumber < lBNumber then
        Exit(-1);

      if lANumber > lBNumber then
        Exit(1);

      Exit(0);
    end;

    Result := CompareText(pA, pB);
  end;

begin
  if not Assigned(pDataSet) then
    Exit;

  if pFieldName.IsEmpty then
    Exit;

  if pDataSet.RecordCount <= 1 then
    Exit;

  CollectDataFields(pDataSet, lFields, lFieldNames);
  if Length(lFields) = 0 then
    Exit;

  lTargetFieldIndex := -1;
  for lI := 0 to High(lFields) do
    if SameText(lFields[lI].FieldName, pFieldName) then
    begin
      lTargetFieldIndex := lI;
      Break;
    end;

  if lTargetFieldIndex < 0 then
    Exit;

  CacheOriginalOrder(pDataSet);

  pDataSet.DisableControls;
  try
    lRows := CaptureRows(pDataSet, lFields);

    for lI := 0 to High(lRows) - 1 do
    begin
      for lJ := lI + 1 to High(lRows) do
      begin
        lA := lRows[lI][lTargetFieldIndex];
        lB := lRows[lJ][lTargetFieldIndex];
        lCompare := CompareValues(lA, lB);

        if pDesc then
          lCompare := -lCompare;

        if lCompare > 0 then
        begin
          lTemp := lRows[lI];
          lRows[lI] := lRows[lJ];
          lRows[lJ] := lTemp;
        end;
      end;
    end;

    RewriteDataSetRows(pDataSet, lFieldNames, lRows);
  finally
    pDataSet.EnableControls;
  end;
end;

class procedure TClientTablePagination.ToggleAndSortDataSet(
  const pTable: TDBTableControl; const pDataSet: TXDataWebDataSet;
  const pCol, pRow: Integer; var pSortField: string; var pSortDesc: Boolean);
var
  lField: string;
begin
  if pCol < 0 then
    Exit;

  if pRow > 0 then
    Exit;

  lField := ResolveSortFieldFromColumn(pTable, pCol);
  if lField.IsEmpty then
    Exit;

  if SameText(pSortField, lField) then
  begin
    if not pSortDesc then
      pSortDesc := True
    else
    begin
      pSortField := EmptyStr;
      pSortDesc := False;
      RestoreOriginalOrder(pDataSet);
      UpdateHeaderVisualState(pTable, pSortField, pSortDesc);
      Exit;
    end;
  end
  else
  begin
    pSortField := lField;
    pSortDesc := False;
  end;

  SortDataSet(pDataSet, pSortField, pSortDesc);
  UpdateHeaderVisualState(pTable, pSortField, pSortDesc);
end;

class procedure TClientTablePagination.Apply(const pContainerId, pInfoId,
  pPaginationId: string; const pPageSize, pPage: Integer;
  const pEnableSort: Boolean);
begin
  ApplyFiltered(pContainerId, pInfoId, pPaginationId, pPageSize, EmptyStr, pPage,
    pEnableSort);
end;

class procedure TClientTablePagination.ApplyFiltered(const pContainerId, pInfoId,
  pPaginationId: string; const pPageSize: Integer; const pSearchText: string;
  const pPage: Integer; const pEnableSort: Boolean);
begin
  asm
    var lContainer = document.getElementById(pContainerId);
    var lInfo = document.getElementById(pInfoId);
    var lPagination = document.getElementById(pPaginationId);
    var lHeaderRow = null;

    if (!lContainer) {
      return;
    }

    var lTable = lContainer.querySelector('table');
    var lHeaders = [];
    if (lTable) {
    var lBadHeaders = lTable.querySelectorAll('tbody th');

    lBadHeaders.forEach(function(th) {
      var td = document.createElement('td');

      td.innerHTML = th.innerHTML;
      td.className = th.className;

      th.parentNode.replaceChild(td, th);
    });

      lHeaders = Array.prototype.slice.call(lTable.querySelectorAll('thead th'));
      if (lHeaders.length === 0) {
        lHeaderRow = lTable.querySelector('tr:first-child');
        if (lHeaderRow) {
          lHeaders = Array.prototype.slice.call(lHeaderRow.querySelectorAll('th'));
          if (lHeaders.length === 0) {
            lHeaders = Array.prototype.slice.call(lHeaderRow.querySelectorAll('td'));
          }
        }
      }
    }

    var lRows = Array.prototype.slice.call(lContainer.querySelectorAll('table tbody tr'));
    if (lRows.length === 0) {
      lRows = Array.prototype.slice.call(lContainer.querySelectorAll('table tr'));
    }

    lRows = lRows.filter(function(lRow) {
      return !!lRow.querySelector('td');
    });

    if (lHeaderRow) {
      lRows = lRows.filter(function(lRow) {
        return lRow !== lHeaderRow;
      });
    }

    var lNormalize = function(lValue) {
      return String(lValue || '')
        .replace(/\s+/g, ' ')
        .trim()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toUpperCase();
    };

    var lGetVisibleElements = function(lElements) {
      return lElements.filter(function(lElement) {
        if (!lElement) {
          return false;
        }

        var lStyle = window.getComputedStyle(lElement);
        return lStyle && lStyle.display !== 'none' && lStyle.visibility !== 'hidden';
      });
    };

    var lGetVisibleCells = function(lRow) {
      var lCells = Array.prototype.slice.call(lRow.querySelectorAll('td'));
      return lGetVisibleElements(lCells);
    };

    lRows.forEach(function(lRow, lIndex) {
      if (!lRow.hasAttribute('data-original-index')) {
        lRow.setAttribute('data-original-index', String(lIndex));
      }
    });

    var lSortVisibleIndex = parseInt(lContainer.getAttribute('data-sort-visible-index') || '-1', 10);
    var lSortMode = String(lContainer.getAttribute('data-sort-mode') || 'none');

    if (pEnableSort && lSortMode === 'none') {
      lRows.sort(function(lA, lB) {
        var lAIndex = parseInt(lA.getAttribute('data-original-index') || '0', 10) || 0;
        var lBIndex = parseInt(lB.getAttribute('data-original-index') || '0', 10) || 0;
        return lAIndex - lBIndex;
      });
    } else if (pEnableSort && lSortVisibleIndex >= 0) {
      var lDirection = lSortMode === 'desc' ? -1 : 1;

      var lParseSortValue = function(lRawText) {
        var lText = String(lRawText || '').trim();
        if (lText === '') {
          return { num: null, text: '' };
        }

        // Data no formato dd/mm/yy[yy] [hh:nn[:ss]]
        var lDateMatch = lText.match(/^(\d{2})\/(\d{2})\/(\d{2,4})(?:\s+(\d{2}):(\d{2})(?::(\d{2}))?)?$/);
        if (lDateMatch) {
          var lYear = parseInt(lDateMatch[3], 10);
          if (lYear < 100) { lYear += 2000; }
          var lTs = Date.UTC(lYear, parseInt(lDateMatch[2], 10) - 1,
            parseInt(lDateMatch[1], 10), parseInt(lDateMatch[4] || '0', 10),
            parseInt(lDateMatch[5] || '0', 10), parseInt(lDateMatch[6] || '0', 10));
          return { num: lTs, text: '' };
        }

        // Numero inteiro ou decimal (aceita virgula decimal)
        var lNumericText = lText.replace(/\s/g, '').replace(',', '.');
        if (/^-?\d+(\.\d+)?$/.test(lNumericText)) {
          return { num: Number(lNumericText), text: '' };
        }

        return { num: null, text: lNormalize(lText) };
      };

      // Valor de ordenacao da celula: usa o atributo data-sort-value (proprio
      // ou de algum filho) quando existir - util para celulas cujo conteudo e
      // um icone/HTML sem texto (ex.: boolean como check/times). Caso contrario
      // cai no texto visivel.
      var lGetCellSortText = function(lCell) {
        if (!lCell) {
          return '';
        }

        var lOwn = lCell.getAttribute('data-sort-value');
        if (lOwn !== null && lOwn !== undefined) {
          return lOwn;
        }

        var lMarked = lCell.querySelector('[data-sort-value]');
        if (lMarked) {
          return lMarked.getAttribute('data-sort-value') || '';
        }

        return lCell.textContent || '';
      };

      var lDecorated = lRows.map(function(lRow) {
        var lVisibleCells = lGetVisibleCells(lRow);
        var lRawText = '';
        if (lSortVisibleIndex < lVisibleCells.length) {
          lRawText = lGetCellSortText(lVisibleCells[lSortVisibleIndex]);
        }
        return { row: lRow, key: lParseSortValue(lRawText) };
      });

      lDecorated.sort(function(lA, lB) {
        var lKA = lA.key;
        var lKB = lB.key;
        var lCmp;

        if (lKA.num !== null && lKB.num !== null) {
          lCmp = lKA.num - lKB.num;
        } else if (lKA.num !== null) {
          lCmp = -1;
        } else if (lKB.num !== null) {
          lCmp = 1;
        } else {
          lCmp = lKA.text.localeCompare(lKB.text);
        }

        return lCmp * lDirection;
      });

      lRows = lDecorated.map(function(lItem) { return lItem.row; });
    }

    if (lRows.length > 0) {
      var lParentNode = lRows[0].parentNode;
      if (lParentNode) {
        lRows.forEach(function(lRow) {
          lParentNode.appendChild(lRow);
        });
      }
    }

    var lSearch = String(pSearchText || '').toUpperCase().trim();
    // Termo reduzido a digitos: permite buscar CNPJ/CPF/telefone tanto
    // formatado ('12.345.678/0001-90') quanto so com os numeros ('12345678').
    var lSearchDigits = lSearch.replace(/\D/g, '');
    var lFilteredRows = lRows.filter(function(lRow) {
      if (!lSearch) {
        return true;
      }

      var lText = String(lRow.textContent || '').toUpperCase();
      if (lText.indexOf(lSearch) >= 0) {
        return true;
      }

      if (lSearchDigits.length > 0) {
        return lText.replace(/\D/g, '').indexOf(lSearchDigits) >= 0;
      }

      return false;
    });

    var lSafePageSize = Math.max(1, pPageSize || 10);
    var lTotal = lFilteredRows.length;
    var lTotalPages = Math.max(1, Math.ceil(lTotal / lSafePageSize));
    var lStoredPage = parseInt(lContainer.getAttribute('data-page') || '1', 10) || 1;
    var lRequestedPage = (pPage && pPage > 0) ? pPage : lStoredPage;
    var lPage = Math.min(Math.max(lRequestedPage, 1), lTotalPages);

    var lRender = function(pTargetPage) {
      var lSafePage = Math.min(Math.max(pTargetPage, 1), lTotalPages);
      var lStartIndex = (lSafePage - 1) * lSafePageSize;
      var lEndIndex = lStartIndex + lSafePageSize;

      lRows.forEach(function(lRow) {
        lRow.style.display = 'none';
      });

      lFilteredRows.forEach(function(lRow, lIndex) {
        lRow.style.display = (lIndex >= lStartIndex && lIndex < lEndIndex) ? '' : 'none';
      });

      if (lInfo) {
        if (lTotal === 0) {
          lInfo.textContent = 'Exibindo 0 a 0 de 0 resultados';
        } else {
          lInfo.textContent =
            'Exibindo ' + (lStartIndex + 1) + ' a ' + Math.min(lEndIndex, lTotal) +
            ' de ' + lTotal + ' resultados';
        }
      }

      if (lPagination) {
        lPagination.innerHTML = '';
        lPagination.style.display = 'flex';
        lPagination.style.alignItems = 'center';
        lPagination.style.gap = '4px';

        var lCreateLink = function(lLabel, lTargetPage, lIsCurrent, lIsDisabled, lIsEdge) {
          var lA = document.createElement('a');
          lA.href = '#';
          lA.className = 'paginate_button';
          lA.textContent = lLabel;
          lA.style.display = 'inline-flex';
          lA.style.alignItems = 'center';
          lA.style.justifyContent = 'center';
          lA.style.minWidth = lIsEdge ? '72px' : '36px';
          lA.style.height = '36px';
          lA.style.padding = lIsEdge ? '0 12px' : '0';
          lA.style.border = '1px solid #d8dbe0';
          lA.style.borderRadius = '999px';
          lA.style.fontSize = '14px';
          lA.style.textDecoration = 'none';
          lA.style.userSelect = 'none';

          if (lIsCurrent) {
            lA.style.backgroundColor = '#0d6efd';
            lA.style.color = '#fff';
            lA.style.borderColor = '#0d6efd';
            lA.style.fontWeight = '600';
          } else {
            lA.style.backgroundColor = '#f8f9fb';
            lA.style.color = '#5b6270';
          }

          if (lIsDisabled) {
            lA.style.opacity = '0.55';
            lA.style.pointerEvents = 'none';
          }

          if (!lIsDisabled && lTargetPage > 0) {
            lA.onclick = function(lEvent) {
              lEvent.preventDefault();
              lRender(lTargetPage);
            };
          }

          return lA;
        };

        var lCreateEllipsis = function() {
          var lSpan = document.createElement('span');
          lSpan.textContent = '...';
          lSpan.style.display = 'inline-flex';
          lSpan.style.alignItems = 'center';
          lSpan.style.justifyContent = 'center';
          lSpan.style.minWidth = '24px';
          lSpan.style.height = '36px';
          lSpan.style.color = '#5b6270';
          return lSpan;
        };

        lPagination.appendChild(lCreateLink('Anterior', lSafePage - 1, false, lSafePage <= 1, true));

        var lMaxVisiblePages = 6;
        var lStartPage = Math.max(1, lSafePage - Math.floor(lMaxVisiblePages / 2));
        var lEndPage = lStartPage + lMaxVisiblePages - 1;

        if (lEndPage > lTotalPages) {
          lEndPage = lTotalPages;
          lStartPage = Math.max(1, lEndPage - lMaxVisiblePages + 1);
        }

        if (lStartPage > 1) {
          lPagination.appendChild(lCreateLink('1', 1, lSafePage === 1, false, false));
        }

        if (lStartPage > 2) {
          lPagination.appendChild(lCreateEllipsis());
        }

        for (var lPagina = lStartPage; lPagina <= lEndPage; lPagina++) {
          lPagination.appendChild(lCreateLink(String(lPagina), lPagina, lPagina === lSafePage, false, false));
        }

        if (lEndPage < lTotalPages - 1) {
          lPagination.appendChild(lCreateEllipsis());
        }

        if (lEndPage < lTotalPages) {
          lPagination.appendChild(lCreateLink(String(lTotalPages), lTotalPages,
            lSafePage === lTotalPages, false, false));
        }

        lPagination.appendChild(lCreateLink('Próximo', lSafePage + 1,
          false, lSafePage >= lTotalPages, true));
      }

      lContainer.setAttribute('data-page', String(lSafePage));

      if (pEnableSort && lHeaders.length > 0) {
        var lVisibleHeaders = lGetVisibleElements(lHeaders);

        lVisibleHeaders.forEach(function(lHeader, lVisibleIndex) {
          var lHeaderText = String(lHeader.getAttribute('data-sort-label') || lHeader.textContent || '').trim();
          if (!lHeader.getAttribute('data-sort-label')) {
            lHeader.setAttribute('data-sort-label', lHeaderText);
          }

          var lNormalizedHeader = lNormalize(lHeaderText);
          var lIsSortable = true;
          if (lNormalizedHeader === '') {
            lIsSortable = false;
          }
          if (pContainerId === 'tblProdutosAssociar') {
            if (lNormalizedHeader === 'ACOES' || lNormalizedHeader === 'IMAGEM') {
              lIsSortable = false;
            }
          }
          if (pContainerId === 'tblAliados') {
            if (lNormalizedHeader === 'SELECIONAR') {
              lIsSortable = false;
            }
          }

          if (!lIsSortable) {
            lHeader.style.cursor = 'default';
            lHeader.textContent = lHeaderText;
            lHeader.onclick = null;
            return;
          }

          lHeader.style.cursor = 'pointer';
          lHeader.style.userSelect = 'none';
          lHeader.style.whiteSpace = 'nowrap';

          var lIndicator = '';
          if ((pContainerId !== 'tblAliados') && (lVisibleIndex === lSortVisibleIndex)) {
            if (lSortMode === 'asc') {
              lIndicator = ' ▲';
            } else if (lSortMode === 'desc') {
              lIndicator = ' ▼';
            }
          }

          lHeader.textContent = lHeaderText + lIndicator;

          lHeader.onclick = function(lEvent) {
            lEvent.preventDefault();

            var lCurrentVisibleIndex = parseInt(lContainer.getAttribute('data-sort-visible-index') || '-1', 10);
            var lCurrentMode = String(lContainer.getAttribute('data-sort-mode') || 'none');
            var lNewMode = 'asc';

            if (lCurrentVisibleIndex === lVisibleIndex) {
              if (lCurrentMode === 'asc') {
                lNewMode = 'desc';
              } else if (lCurrentMode === 'desc') {
                lNewMode = 'none';
              }
            }

            if (lNewMode === 'none') {
              lContainer.setAttribute('data-sort-visible-index', '-1');
              lContainer.setAttribute('data-sort-mode', 'none');
            } else {
              lContainer.setAttribute('data-sort-visible-index', String(lVisibleIndex));
              lContainer.setAttribute('data-sort-mode', lNewMode);
            }

            if (pContainerId === 'tblAliados') {
              // Exibe o loading durante a ordenacao (ver AplicarComLoading).
              pas.UClientTablePagination.TClientTablePagination.AplicarComLoading(
                pContainerId, pInfoId, pPaginationId, pSearchText, pPageSize);
            } else {
              pas.UClientTablePagination.TClientTablePagination.ApplyFiltered(
                pContainerId, pInfoId, pPaginationId, pPageSize, pSearchText, 1, true);
            }
          };
        });
      }
    };

    lRender(lPage);
  end;
end;

class procedure TClientTablePagination.OcultarLoading;
begin
  TUtils.OcultarDivLoading;
end;

class procedure TClientTablePagination.AplicarComLoading(const pContainerId,
  pInfoId, pPaginationId, pSearchText: string; const pPageSize: Integer);
begin
  // Mostra o loading e adia a ordenacao com setTimeout(0): a ordenacao/render
  // e sincrona e bloquearia a pintura, entao sem o adiamento o spinner nem
  // chegaria a aparecer. Ao concluir (mesmo em caso de erro) oculta o loading.
  TUtils.ChamarDivLoading;

  asm
    setTimeout(function() {
      try {
        pas.UClientTablePagination.TClientTablePagination.ApplyFiltered(
          pContainerId, pInfoId, pPaginationId, pPageSize, pSearchText, 1, true);
      } finally {
        pas.UClientTablePagination.TClientTablePagination.OcultarLoading();
      }
    }, 0);
  end;
end;

class procedure TClientTablePagination.ApplyFromControls(const pContainerId, pInfoId,
  pPaginationId, pPageSizeControlId, pSearchControlId: string;
  const pDefaultPageSize, pPage: Integer; const pEnableSort: Boolean);
var
  lPageSize: Integer;
  lSearch: string;
begin
  lPageSize := pDefaultPageSize;
  lSearch := EmptyStr;

  asm
    var lPageSizeControl = document.getElementById(pPageSizeControlId);
    var lSearchControl = document.getElementById(pSearchControlId);

    if (lPageSizeControl) {
      lPageSize = parseInt(String(lPageSizeControl.value || pDefaultPageSize), 10) || pDefaultPageSize;
    }

    if (lSearchControl) {
      lSearch = String(lSearchControl.value || '');
    }
  end;

  ApplyFiltered(pContainerId, pInfoId, pPaginationId, lPageSize, lSearch, pPage,
    pEnableSort);
end;

class procedure TClientTablePagination.ApplyAsync(const pContainerId, pInfoId,
  pPaginationId: string; const pPageSize, pPage: Integer;
  const pEnableSort: Boolean);
begin
  asm
    setTimeout(function() {
      pas.UClientTablePagination.TClientTablePagination.Apply(pContainerId, pInfoId,
        pPaginationId, pPageSize, pPage, pEnableSort);
    }, 0);
  end;
end;

class procedure TClientTablePagination.ApplyFromControlsAsync(
  const pContainerId, pInfoId, pPaginationId, pPageSizeControlId,
  pSearchControlId: string; const pDefaultPageSize, pPage: Integer;
  const pEnableSort: Boolean);
begin
  asm
    setTimeout(function() {
      pas.UClientTablePagination.TClientTablePagination.ApplyFromControls(
        pContainerId, pInfoId, pPaginationId, pPageSizeControlId,
        pSearchControlId, pDefaultPageSize, pPage, pEnableSort);
    }, 0);
  end;
end;

end.
